import Header from "./Header";
import JsonFooter from "./JsonFooter";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const location = useLocation();
  const isProductDetail = location.pathname.startsWith("/productDetail");
  const [detailScrolled, setDetailScrolled] = useState(false);

  useEffect(() => {
    if (!isProductDetail) setDetailScrolled(false);
  }, [isProductDetail]);

  return (
    <div className={`lfx-app ${isProductDetail && detailScrolled ? "lfx-app--detail-scrolled" : ""}`}>
      <Header />
      <div className="lfx-main">
        <main
          className="lfx-page"
          onScroll={(e) => {
            if (!isProductDetail) return;
            const top = e.currentTarget.scrollTop || 0;
            setDetailScrolled(top > 24);
          }}
        >
          {children}
          <JsonFooter />
        </main>
      </div>
    </div>
  );
}
